import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

function dm_c_10_awards_partnerships() {
  const sections = document.querySelectorAll('section.c-10-awards-partnerships');

  sections.forEach((section) => {
    const viewport = section.querySelector('.swiper');
    if (!viewport) return;

    // Swiper structure
    let wrapper = viewport.querySelector('.swiper-wrapper');
    let slides = Array.from(viewport.querySelectorAll('.slide')); 

    if (!wrapper) {
      wrapper = document.createElement('div');
      wrapper.className = 'swiper-wrapper';
      slides.forEach((el) => el.classList.add('swiper-slide'));
      viewport.replaceChildren(wrapper);
      slides.forEach((el) => wrapper.appendChild(el));
    } else {
      slides.forEach((el) => el.classList.add('swiper-slide'));
    }

    // Scope controls
    const prevButtons = section.querySelectorAll('.swiper-btn.prev');
    const nextButtons = section.querySelectorAll('.swiper-btn.next');

    // breakpoint: enable swiper on md and up (>= 768px)
    const mq = '(min-width: 768px)';
    let swiperInstance = null;
    const prevHandlers = new Map();
    const nextHandlers = new Map();
    let resizeTimer = null;

    function addButtonListeners() {
      prevButtons.forEach((btn) => {
        // only add handler to non-primary buttons (primary is wired via Swiper navigation)
        const handler = (e) => { e.preventDefault(); if (swiperInstance) swiperInstance.slidePrev(); };
        if (btn !== prevButtons[0]) {
          btn.addEventListener('click', handler);
          prevHandlers.set(btn, handler);
        }
      });
      nextButtons.forEach((btn) => {
        const handler = (e) => { e.preventDefault(); if (swiperInstance) swiperInstance.slideNext(); };
        if (btn !== nextButtons[0]) {
          btn.addEventListener('click', handler);
          nextHandlers.set(btn, handler);
        }
      });
    }

    function removeButtonListeners() {
      prevHandlers.forEach((handler, btn) => btn.removeEventListener('click', handler));
      nextHandlers.forEach((handler, btn) => btn.removeEventListener('click', handler));
      prevHandlers.clear();
      nextHandlers.clear();
    }

    function initSwiper() {
      if (swiperInstance) return;
      if (!window.matchMedia(mq).matches) return;

      swiperInstance = new Swiper(viewport, {
        modules: [Navigation],
        slidesPerView: 3,
        spaceBetween: 16,
        autoHeight: false,
        speed: 600,
        navigation: {
          prevEl: prevButtons[0] || null,
          nextEl: nextButtons[0] || null
        },
      });

      addButtonListeners();
    }

    function destroySwiper() {
      if (!swiperInstance) return;
      swiperInstance.destroy(true, true);
      swiperInstance = null;
      removeButtonListeners();
    }

    function onResize() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        if (window.matchMedia(mq).matches) {
          initSwiper();
        } else {
          destroySwiper();
        }
      }, 120);
    }

    // Initial setup: create swiper only on md+ devices
    if (window.matchMedia(mq).matches) {
      initSwiper();
    }

    // Watch for viewport changes
    window.addEventListener('resize', onResize);

    // Clean up if the section is removed from DOM later (optional)
    // Use a MutationObserver to remove listeners if the section itself is removed
    const mo = new MutationObserver(() => {
      if (!document.body.contains(section)) {
        destroySwiper();
        window.removeEventListener('resize', onResize);
        mo.disconnect();
      }
    });
    mo.observe(document.body, { childList: true, subtree: true });
  });
}

export { dm_c_10_awards_partnerships };